const variantSelects = document.querySelector("variant-radios");
const fieldsets = Array.from(variantSelects.querySelectorAll("fieldset"));
const productJson = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent);
let selectedOptions = fieldsets.map((fieldset) => {
  return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
});

if(variantSelects != null){
  variantSelects.addEventListener("change", rebuildOptions);
  this.rebuildOptions();
}

// gather a list of valid combinations of options, check to see if the input passed to it matches in a chain of valid options.
function validCombo(inputValue, optionLevel) {
  for (let i = 0; i < productJson.length; i++) {
    if (optionLevel == 0) {
      if (
        productJson[i].option1 == inputValue &&
        productJson[i].option2 == selectedOptions[1]
      ) {
        return true;
      }
    } else if (optionLevel == 1) {
      if (
        productJson[i].option1 == selectedOptions[0] &&
        productJson[i].option2 == inputValue
      ) {
        return true;
      }
    } else {
      if (
        productJson[i].option1 == selectedOptions[0] &&
        productJson[i].option2 == selectedOptions[1] &&
        productJson[i].option3 == inputValue
      ) {
        return true;
      }
    }
  }
  return false;
}

function rebuildOptions() {
  selectedOptions = fieldsets.map((fieldset) => {
    return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
  });
  //loop through the option sets starting from the 2nd set and disable any invalid options
  for (
    let optionLevel = 0, n = fieldsets.length;
    optionLevel < n;
    optionLevel++
  ) {
    const inputs = fieldsets[optionLevel].querySelectorAll("input");

    inputs.forEach((input) => {
      input.disabled = validCombo(input.value, optionLevel) ? false : true;
      //get the label for the current input (this is what the user clicks, the "pill")
      const label = fieldsets[optionLevel].querySelector(
        `label[for="${input.id}"]`
      );
    });
  }

  //if the default selected option is disabled with the function above, select the first available option instead
  for (
    let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false;
    optionLevel < fieldsetsLength && !change;
    optionLevel++
  ) {
      if (
        fieldsets[optionLevel].querySelector("input:checked").disabled === true
      ) {
        change = fieldsets[optionLevel].querySelector(
          "input:not(:disabled)"
        ).checked = true;
      }
    //if a new option has been selected, restart the whole process
    if (change)
      variantSelects.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
